import { render, staticRenderFns } from "./ManageMenuEdit.vue?vue&type=template&id=6d070922&scoped=true"
import script from "./ManageMenuEdit.vue?vue&type=script&lang=js"
export * from "./ManageMenuEdit.vue?vue&type=script&lang=js"
import style0 from "./ManageMenuEdit.vue?vue&type=style&index=0&id=6d070922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d070922",
  null
  
)

export default component.exports